<!-- <p-toast></p-toast> -->
<div *ngIf="!isKYCCompleted">
    <div *ngIf="!openPPIDDataCard" class="p-fluid p-formgrid justify-content-center ver-dialog mt-2 outer-div"
        style="display: flex; flex-wrap:wrap">
        <img src="../../../../assets/aadhar/aadhar1.jpeg" alt="bg" style="width:100%;">
        <div class="inner-div">
            <div class="field md:col-12 col-12 aadhar-number">
                <label [style]="{color: 'rgb(3, 2, 2)'}">{{'AADHAR_NUMBER'| translate}}: <label *ngIf="!showTextField && aadharNumber"
                        class="px-2" [style]="{color: 'rgb(148, 9, 9)'}">{{ aadharNumber }}</label>
                </label>
                <input *ngIf="showTextField" [readonly]="false" type="text" pInputText [(ngModel)]="aadharNumber" />
            </div>

            <div *ngIf="!isMemberOTPSent" class="field md:col-12 col-12 otp-field">

                <label class="form-check-label pt-2" for="consentCheckbox" [style]="{color: 'red'}"><input
                        type="checkbox" class="form-check-input" id="consentCheckbox"
                        [(ngModel)]="consentCheckboxValue">
                    &nbsp; I hereby declare the above-mentioned Aadhaar number belongs to me.
                </label>
            </div>


            <div *ngIf="!isMemberOTPSent" class="field md:col-12 col-12">
                <button [disabled]="!consentCheckboxValue" pButton pRipple label="{{ 'SUBMIT' | translate }}"
                    class="p-button-success fancy-button" (click)="onSubmitConsent()">
                </button>
            </div>

            <div *ngIf="showStatusMessage" class="field md:col-12 col-12 response-text">
                <span [ngStyle]="{'color': 'black'}">Status:&nbsp;</span>
                <span [ngStyle]="{'color': isErrorStatus ? 'red' : 'green'}">{{ statusMessageText }}</span>
            </div>
            <!-- </div> -->
            <!-- </div>

            <div class="card"> -->
            <div *ngIf="isMemberOTPSent" class="field md:col-12 col-12 otp-field">
                <label [style]="{color: 'rgb(3, 2, 2)'}">{{'Enter OTP'| translate}}:
                </label>
                <input pInputText maxlength="6" pattern="^[0-9]{6}$" [(ngModel)]="memberIdOTPValue" placeholder="OTP"
                    type="number">
            </div>

            <div *ngIf="isMemberOTPSent" class="field md:col-12 col-12">
                <button pButton pRipple label="{{ 'SUBMIT_OTP' | translate}}" class="p-button-success"
                    (click)="onSubmitMemIdOTP()"></button>
            </div>
        </div>

        <!-- <div class="p-fluid p-formgrid consent-card"
        style="display: flex; flex-wrap: wrap; justify-content: center; align-items: center;">
        <div class="field md:col-12 col-12"
            style="display: flex; flex-wrap: wrap; justify-content: center; align-items: center;">
            <label>{{'AADHAR_NUMBER' | translate}}:
                <label [style]="{color: 'rgb(168, 32, 32)', 'font-size': '1.3rem'}">{{farmerDetails.Aadhar_No}}</label>
            </label>
        </div>

        <div class="field md:col-12 col-12"
            style="display: flex; flex-wrap: wrap; justify-content: center; align-items: center;">
            <input type="checkbox" class="form-check-input" id="consentCheckbox" [(ngModel)]="consentCheckboxValue">
            <label class="form-check-label pt-2" for="consentCheckbox" [style]="{color: 'red'}">
                I hereby declare the above-mentioned Aadhaar number belongs to me
            </label>
        </div>

        <div class="field md:col-3 col-12">
            <button [disabled]="!consentCheckboxValue" pButton pRipple label="{{ 'SUBMIT' | translate }}"
                class="p-button-success fancy-button" (click)="onSubmitConsent()">
            </button>
            <button type="button" (click)="addNewItem('yesss')">Add to parent's list</button>
        </div>
        </div> -->

    </div>

    <div class="col-12 pppId-card" *ngIf="openPPIDDataCard">
        <!-- <div *ngIf="pppIDData" class="card" reflow="true"> -->
        <div class="card" reflow="true">
            <h5 [ngStyle]="{'color': 'rgb(125, 22, 22)', 'font-weight': 'bold'}">{{'Data from PPP Portal' | translate}}
            </h5>

            <div class="flex flex-wrap">
                <!-- <div class="field col-12 md:col-3">
                    <span>
                        <label htmlFor="block">{{'Family Id' | translate}}:</label>
                        <span><b> {{pppIDData.familyID}}</b></span>
                    </span>
                </div>
                <div class="field col-12 md:col-3">
                    <span>
                        <label htmlFor="block">{{'Member Id' | translate}}:</label>
                        <span><b> {{pppIDData.memberID}}</b></span>
                    </span>
                </div> -->
                <div class="field col-12 md:col-3">
                    <span>
                        <label htmlFor="block">{{'Name' | translate}}:</label>
                        <span><b> {{pppIDData?.fullName}}</b></span>
                    </span>
                </div>
                <div class="field col-12 md:col-3">
                    <span>
                        <label htmlFor="block">{{'DOB' | translate}}:</label>
                        <span><b> {{pppIDData?.dob}}</b></span>
                    </span>
                </div>
                <div class="field col-12 md:col-3">
                    <span>
                        <label htmlFor="block">{{'Gender' | translate}}:</label>
                        <span><b> {{pppIDData?.gender}}</b></span>
                    </span>
                </div>
                <div class="field col-12 md:col-3">
                    <span>
                        <label htmlFor="block">{{'Caste' | translate}}:</label>
                        <span><b> {{pppIDData?.casteCategoryName}}</b></span>
                    </span>
                </div>
                <div class="field col-12 md:col-3">
                    <span>
                        <label htmlFor="block">{{'Father Name' | translate}}:</label>
                        <span><b> {{pppIDData?.fatherFullName}}</b></span>
                    </span>
                </div>
                <div class="field col-12 md:col-3">
                    <span>
                        <label htmlFor="block">{{'Mother Name' | translate}}:</label>
                        <span><b> {{pppIDData?.motherFullName}}</b></span>
                    </span>
                </div>
                <div class="field col-12 md:col-3">
                    <span>
                        <label htmlFor="block">{{'House No' | translate}}:</label>
                        <span><b> {{pppIDData?.houseNo}}</b></span>
                    </span>
                </div>
                <div class="field col-12 md:col-3">
                    <span>
                        <label htmlFor="block">{{'Street' | translate}}:</label>
                        <span><b> {{pppIDData?.streetNo}}</b></span>
                    </span>
                </div>
                <div class="field col-12 md:col-3">
                    <span>
                        <label htmlFor="block">{{'Landmark' | translate}}:</label>
                        <span><b> {{pppIDData?.address_LandMark}}</b></span>
                    </span>
                </div>
                <div class="field col-12 md:col-3">
                    <span>
                        <label htmlFor="block">{{'Tehsil' | translate}}:</label>
                        <span><b> {{pppIDData?.tehsilName}}</b></span>
                    </span>
                </div>
                <div class="field col-12 md:col-3">
                    <span>
                        <label htmlFor="block">{{'District' | translate}}:</label>
                        <span><b> {{pppIDData?.districtName}}</b></span>
                    </span>
                </div>
                <div class="field col-12 md:col-3">
                    <span>
                        <label htmlFor="block">{{'Pincode' | translate}}:</label>
                        <span><b> {{pppIDData?.pinCode}}</b></span>
                    </span>
                </div>

                <div *ngIf="farmerId == null">
                <form [formGroup]="farmersDetailsForm">
                    <div class="flex flex-wrap upload-section">
                        <div class="field col-12 md:col-6">
                            <label htmlFor="villageCode">{{'VILLAGE' | translate}}</label>
                            <p-autoComplete formControlName="village" placeholder="Search"
                            id="dd" [dropdown]="true" [multiple]="false" [suggestions]="filteredVillage"
                            (completeMethod)="filterVillage($event)" field="Name" value="Code"
                            [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && farmersFormControls.village.errors }"></p-autoComplete>

                            <div *ngIf="isSubmitted && farmersFormControls.village.errors" class="invalid-feedback">
                                <div *ngIf="farmersFormControls.village.errors.required">{{'VILLAGE_NAME_IS_REQUIRED' | translate}}
                                </div>
                            </div>
                        </div>

                        <div class="field col-12 md:col-6">
                            <label htmlFor="mfmbNo">{{'MFMB_NO' | translate}}</label>
                            <input maxlength="8" pattern="^[0-9]{8}$" pKeyFilter="int" formControlName="mfmbNo"
                                pInputText id="block" type="text"
                                [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && farmersFormControls.mfmbNo.errors }" />
                            <div *ngIf="isSubmitted && farmersFormControls.mfmbNo.errors" class="invalid-feedback">
                                <div *ngIf="farmersFormControls.mfmbNo.errors.required">{{'MFMB_NO_REQUIRED' |
                                    translate}}</div>
                                <div *ngIf="farmersFormControls.mfmbNo.errors.minlength">
                                    {{'MFMB_NO_REQUIRED_NO_IS_SHOULD_BE_OF_12_DIGITS' |
                                    translate}}</div>
                                <div *ngIf="farmersFormControls.mfmbNo.errors.maxlength">
                                    {{'MFMB_NO_REQUIRED_NO_IS_SHOULD_BE_OF_12_DIGITS' |
                                    translate}}</div>
                                <!-- <div *ngIf="farmersFormControls.mfmbNo.errors.pattern">{{'MFMB_NO_REQUIRED_NO_SHOULD_CONTAIN_ONLY_DIGITS' | translate}}</div> -->
                            </div>
                        </div>

                        <div class="field col-12 md:col-6">
                            <label htmlFor="farmerMobNo">{{'MOBILE_NO' | translate}}</label>
                            <input maxlength="10" pattern="^[0-9]{10}$" pKeyFilter="int" formControlName="farmerMobNo"
                                pInputText id="block" type="text"
                                [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && farmersFormControls.farmerMobNo.errors }" />
                            <div *ngIf="isSubmitted && farmersFormControls.farmerMobNo.errors" class="invalid-feedback">
                                <div *ngIf="farmersFormControls.farmerMobNo.errors.required">{{'MOBILE_NO_IS_REQUIRED' |
                                    translate}}</div>
                                <div *ngIf="farmersFormControls.farmerMobNo.errors.minlength">
                                    {{'MOBILE_NO_SHOULD_BE_OF_10_DIGITS' |
                                    translate}}</div>
                                <div *ngIf="farmersFormControls.farmerMobNo.errors.maxlength">
                                    {{'MOBILE_NO_SHOULD_BE_OF_10_DIGITS' |
                                    translate}}</div>
                                <!-- <div *ngIf="farmersFormControls.mfmbNo.errors.pattern">{{'MFMB_NO_REQUIRED_NO_SHOULD_CONTAIN_ONLY_DIGITS' | translate}}</div> -->
                            </div>
                        </div>


                        <div class="field col-12 md:col-6">
                            <label htmlFor="block">{{'FARMER_PHOTO' | translate}}</label>
                            <div class="flex">
                                <p-fileUpload accept=".jpeg,.pdf,.jpg" #farmerPhotoFileUpload [customUpload]="true"
                                    (uploadHandler)="onUpload($event, 'farmersPhotoPath', farmerPhotoFileUpload)"
                                    name="myfile[]" mode="basic" [maxFileSize]="5000000"
                                    chooseLabel="{{'BROWSE' | translate}}" [auto]="true">
                                </p-fileUpload>
                                <p-image *ngIf="farmersFormControls.farmersPhotoPath.value"
                                    [src]="farmersFormControls.farmersPhotoPath.value" alt="Image" width="60"
                                    class="ml-2 p-button-rounded p-button-success" iconPos="left"></p-image>

                                <!-- <div class="image-background ml-2">
              
                            <img [src] ="farmersFormControls.farmersPhotoPath.value" alt="farmer photo" *ngIf="farmersFormControls.farmersPhotoPath.value"  class="ml-2 p-button-rounded p-button-success" iconPos="left">
                          </div>
              
                          <button *ngIf="farmersFormControls.farmersPhotoPath.value" pButton type="button" icon="pi pi-check" class="ml-2 p-button-rounded p-button-success" iconPos="left"></button> -->
                            </div>
                            <div *ngIf="isSubmitted && farmersFormControls.farmersPhotoPath.errors"
                                class="invalid-feedback">
                                <div *ngIf="farmersFormControls.farmersPhotoPath.errors.required">
                                    {{'FARMERS_PHOTO_IS_REQUIRED' |
                                    translate}}</div>
                            </div>
                        </div>
                    </div>
                </form>
                </div>



                <div *ngIf="!isAadharOTPSent" class="field md:col-12 col-12 otp-field">
                    <label class="form-check-label pt-2" for="aadharConsentCheckbox" [style]="{color: 'red'}"><input
                            type="checkbox" class="form-check-input" id="aadharConsentCheckbox"
                            [(ngModel)]="aadharConsentCheckboxValue">
                        &nbsp; I hereby declare the above mentioned information belongs to me.
                    </label>
                </div>

                <div *ngIf="!isAadharOTPSent" class="field md:col-12 col-12">
                    <button [disabled]="!aadharConsentCheckboxValue" pButton pRipple label="{{ 'SUBMIT' | translate }}"
                        class="p-button-success fancy-button" (click)="onSubmitAadharConsent()">
                    </button>
                </div>

                <div *ngIf="showStatusMessage && showAadharOTPStatusMsg" class="field md:col-12 col-12 response-text">
                    <span [ngStyle]="{'color': 'black'}">Status:&nbsp;</span>
                    <span [ngStyle]="{'color': isErrorStatus ? 'red' : 'green'}">{{ statusMessageText }}</span>
                </div>

                <!-- <div class="card">
                    <p-messages [(value)]="statusMessageText" [enableService]="false"></p-messages>
                </div> -->

                <!-- aadhar opt box -->
                <div *ngIf="isAadharOTPSent" class="field md:col-12 col-12 aadhar-otp-box"
                    style="display: flex; flex-wrap: wrap; justify-content: center; align-items: center;">
                    <div *ngIf="isAadharOTPSent" class="field md:col-6 col-12 otp-field"
                        style="display: flex; flex-wrap: wrap; justify-content: center; align-items: center;">
                        <label [style]="{color: 'rgb(3, 2, 2)'}">{{'Enter OTP'| translate}}:
                        </label>
                        <input pInputText maxlength="6" [(ngModel)]="aadharOTPValue" placeholder="OTP" type="number">
                    </div>

                    <!-- <div class="aadhar-otp-box"
                        style="display: flex; flex-wrap: wrap; justify-content: center; align-items: center;"> -->
                    <div *ngIf="isAadharOTPSent" class="field md:col-8 col-12">
                        <button pButton pRipple label="{{ 'SUBMIT_OTP' | translate}}" class="p-button-success"
                            (click)="onSubmitAadharOTP()"></button>
                    </div>
                    <!-- </div> -->
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="isKYCCompleted" class="congrats-message-container">
    <div class="congrats-message">
        <i class="pi pi-check-circle"></i>
        <span>Congratulations! Your e-KYC is completed</span>
    </div>
</div>

<!-- <p-dialog header="Error" [(visible)]="displayErrorPopUp" [modal]="true" [closable]="true" [dismissableMask]="true" (onHide)="hideErrorDialog()">
    <span [ngStyle]="{'color': isErrorStatus ? 'red' : 'green', 'font-weight': 'bold'}">{{ statusMessageText }}</span>
</p-dialog> -->

<p-dialog [(visible)]="displayErrorPopUp" [modal]="true" [closable]="true" [dismissableMask]="true"
    (onHide)="hideErrorDialog()">
    <ng-template pTemplate="header">
        <span [ngStyle]="{'color': 'red', 'font-weight': 'bold', 'font-size': '1.2rem'}">Error</span>
    </ng-template>
    <span [ngStyle]="{'color': isErrorStatus ? 'red' : 'green', 'font-weight': 'bold'}">{{ statusMessageText }}</span>
</p-dialog>